module.exports = __webpack_public_path__ + "static/media/12.b1144eb7.jpg";